import { ReactElement, useContext, useMemo } from 'react';
import { ThemeContext } from 'styled-components';
import { LinkId } from '../../../AnalyticsContext/LinkId';
import {
  LogoLink,
  Logo,
  TextLogo,
  WhiteLabelRectangularLogo,
  WhiteLabelSquareLogo,
} from './ClickableLogo.styles';

export const ClickableLogo = ({
  textLogo,
  className,
  newTab = false,
  supportWhiteLabel,
  disableClick,
  ...restProps
}: {
  textLogo?: boolean;
  className?: string;
  newTab?: boolean;
  disableClick?: boolean;
  supportWhiteLabel?: boolean;
}) => {
  const { whiteLabelProps } = useContext(ThemeContext);

  const hasWhiteLabelLogo =
    !!whiteLabelProps?.rectangularLogoUrl || !!whiteLabelProps?.squareLogoUrl;

  const to =
    supportWhiteLabel && hasWhiteLabelLogo
      ? whiteLabelProps?.homepage ?? '#'
      : 'https://healthengine.com.au';

  const ResolvedLogo: ReactElement = useMemo(() => {
    if (supportWhiteLabel && hasWhiteLabelLogo) {
      if (textLogo && whiteLabelProps?.rectangularLogoUrl) {
        return <WhiteLabelRectangularLogo aria-label="Healthengine logo" />;
      } else if (!textLogo && whiteLabelProps?.squareLogoUrl) {
        return <WhiteLabelSquareLogo aria-label="Healthengine logo" />;
      }
    }

    if (textLogo) {
      return <TextLogo name="Healthengine" />;
    }

    return <Logo name="Healthengine" />;
  }, [hasWhiteLabelLogo, textLogo, whiteLabelProps, supportWhiteLabel]);

  return (
    <>
      {disableClick && <> {ResolvedLogo} </>}
      {!disableClick && (
        <LogoLink
          className={className}
          to={to}
          trackingId={LinkId.HEADER_HE_LOGO}
          newTab={newTab}
          role="link"
          aria-label="Healthengine logo"
          {...restProps}
        >
          {ResolvedLogo}
        </LogoLink>
      )}
    </>
  );
};
